import lodash from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import {
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Tooltip,
    withStyles,
    Icon,
    IconButton,
} from '@material-ui/core';
import { Row, Col } from 'antd';
import Moment from 'react-moment';
import { table_styles } from '../../../../components/TableStyles';
import TableLoader from '../../../../components/table/TableLoader';
import TableNoData from '../../../../components/table/TableNoData';
import { GET_CUSTOMERS_LIST_DATA } from '../constants';

const tableCols = [
    { th: '#', width: '1%', align: 'center' },
    { th: 'Customer', align: 'left' },
    { th: 'Phone', align: 'left' },
    { th: 'Email', align: 'left' },
    { th: 'Division', width: '5%', align: 'center' },
    { th: 'Lead Valuation', align: 'center' },
    { th: 'Lead Created At', align: 'center' },
    {
        th: <Tooltip title="Actions" placement="top">
            <div style={{ marginTop: '5px' }}>
                <Icon fontSize="small">flash_on</Icon>
            </div>
        </Tooltip>,
        width: '5%',
        align: 'center',
    },
];

class CustomersTable extends Component {
    componentDidMount() {
        this.refreshData();
    }

    refreshData = lodash.debounce((isCount) => {
        const { dispatch, divisionId, customerPhone } = this.props;

        dispatch({
            type: GET_CUSTOMERS_LIST_DATA,
            isCount,
            urlFilters: { divisionId, customerPhone },
        });
    }, 500, { leading: true, trailing: false });

    buildRow = (customer, customerIdx) => {
        const { pagination, leadProfileAccess } = this.props;
        const { lead } = customer;
        const { created_date } = lead;
        const valuation = lodash.isArray(lead.valuations) && !lodash.isEmpty(lead.valuations) ? lead.valuations[lead.valuations.length - 1].valuation : '-';
        const division = lodash.get(lead, 'ref_lead_source.abbr');

        const leadProfileLink = (
            <Tooltip title="Open Lead Details" placement="top">
                <span>
                    <IconButton
                        color="primary"
                        aria-label="Open Lead Profile"
                        style={{ padding: 5 }}
                    >
                        <Link style={{ lineHeight: '20px' }} to={{ pathname: `/Leads/Lead_profile/${lead._id}` }}>
                            <Icon fontSize="small" color="primary">info_outlined</Icon>
                        </Link>
                    </IconButton>
                </span>
            </Tooltip>
        );

        return (
            <TableRow key={customer._id}>
                <TableCell align={tableCols[0].align}>
                    <span>{pagination.page * pagination.rpp + customerIdx + 1}</span>
                </TableCell>
                <TableCell align={tableCols[1].align}>
                    <span>
                        { customer.full_name }
                    </span>
                </TableCell>
                <TableCell align={tableCols[2].align}>
                    <span>
                        { customer.phone }
                    </span>
                </TableCell>
                <TableCell align={tableCols[3].align}>
                    <span>
                        { customer.email }
                    </span>
                </TableCell>
                <TableCell align={tableCols[4].align}>
                    <span>
                        { division }
                    </span>
                </TableCell>
                <TableCell align={tableCols[5].align}>
                    <span>
                        { valuation }
                    </span>
                </TableCell>
                <TableCell align={tableCols[6].align}>
                    <span>
                        <Tooltip title={<Moment format="D-MM-YYYY HH:mm">{created_date}</Moment>} placement="top">
                            <Moment format="D MMM HH:mm">{created_date}</Moment>
                        </Tooltip>
                    </span>
                </TableCell>
                <TableCell align={tableCols[7].align}>
                    <div style={{ display: 'inline-flex' }}>
                        {
                            leadProfileAccess && leadProfileLink
                        }
                    </div>
                </TableCell>
            </TableRow>
        );
    }

    render() {
        const {
            classes,
            data,
            isLoading,
            leadProfileAccess,
        } = this.props;

        if (data.length === 1 && leadProfileAccess) {
            const leadId = data[0].lead._id;

            return (
                <Redirect
                    to={{
                        pathname: `/Leads/Lead_profile/${leadId}`,
                    }}
                />
            );
        }

        return (
            <Row>
                <Col span={24}>
                    <TableContainer>
                        <Table className={`${classes.table} sbf-table`}>
                            <TableHead>
                                <TableRow>
                                    {
                                        tableCols.map((col, index) => (
                                            <TableCell
                                                // eslint-disable-next-line react/no-array-index-key
                                                key={index}
                                                align={col.align}
                                                style={{
                                                    width: [col.width],
                                                }}
                                            >
                                                {col.th}
                                            </TableCell>
                                        ))
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    !isLoading && lodash.isEmpty(data) && <TableNoData colSpan={tableCols.length} />
                                }
                                {
                                    isLoading ? <TableLoader colSpan={tableCols.length} /> : data.map(this.buildRow)
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        isLoading,
        data,
        dataCount,
        pagination,
    } = state.Leads.CustomersList;

    return {
        isLoading, data, dataCount, pagination,
    };
};

export default connect(mapStateToProps)(withStyles(table_styles)(CustomersTable));



// WEBPACK FOOTER //
// ./src/modules/Leads/CustomersList/components/CustomersTable.js